














import Vue from 'vue';

export default Vue.extend({
  name: 'LoginView',
  data: () => ({
    login: '',
    password: '',
  }),
  mounted() {
    this.$store.dispatch('logout');
  },
  methods: {
    loginCall() {
      const action = 'login';
      const login = this.login;
      const password = this.password;
      this.$store
        .dispatch('login', {
          action,
          login,
          password,
        })
        .then(() => {
          this.$router.push('/dashboard');
        })
        .catch(() => {
          console.log('invalid login');
        });
    },
  },
});
